import { SvgIcon, type SvgIconProps } from "@mui/material"

export const DropdownArrowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 10 8">
      <path
        d="M8.825 0.9125L5 4.72917L1.175 0.9125L0 2.0875L5 7.0875L10 2.0875L8.825 0.9125Z"
        fill="currentColor"
        fillOpacity="0.56"
      />
    </SvgIcon>
  )
}
